<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <Select
            label="Status Code"
            name="status_code"
            v-model="form.status_code"
            :options="[
                { value: '301', name: '301 Moved Permanently' },
                { value: '302', name: '302 Found' },
            ]"
            :error="errors.status_code ? errors.status_code[0] : null"
        />

        <input-text
            name="from"
            label="* From"
            class="mt-3"
            v-model="form.from"
            :error="errors.from ? errors.from[0] : null"
            :maxlength=255
        />

            <p class="my-1 text-xs text-gray-600">For wildcards always provide * in the end</p>

        </input-text>

        <input-text
            name="to"
            label="* To"
            v-model="form.to"
            class="mt-3"
            :error="errors.to ? errors.to[0] : null"
            :maxlength=255
        />

            <p class="my-1 text-xs text-gray-600">You can use :splat to replace the wildcard if you used a wildcard in "From"</p>

        </input-text>


        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    name: "RedirectForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                status_code: this.getFormData("status_code"),
                from: this.getReferenceData("from"),
                to: this.getReferenceData("to"),
            },
        };
    }
};
</script>
